var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('app-header')]},proxy:true},{key:"sidebar",fn:function(){return [_c('admin-aside')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }